export const FORMAT_SHORT = 'll';
export const FORMAT_LONG_DAY = 'L';
export const FORMAT_LONG_TIME = 'LT';
export const FORMAT_LONG = `${FORMAT_LONG_DAY} ${FORMAT_LONG_TIME}`;
export const PARSE_FORMATS = [FORMAT_LONG, FORMAT_LONG_DAY, FORMAT_SHORT];
